import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import React, { PureComponent } from 'react';

import * as basePropTypes from 'src/constants/propTypes/base';
import * as featuredCollectionsActions from 'src/actions/featuredCollections';

import actionTypes from 'src/constants/actionTypes';
import AllFeaturedCollections from 'src/components/featuredCollections/All';

class FunctionalAll extends PureComponent {
  static propTypes = {
    actions        : basePropTypes.actions.isRequired,
    collections    : PropTypes.object.isRequired,
    history        : basePropTypes.history.isRequired,
    isActive       : PropTypes.bool,
    location       : basePropTypes.location.isRequired,
  };

  componentDidMount() {
    this.props.actions.featuredCollections.getAll();
  }

  // Navigate imperatively on success (mirrors studySets/New) rather than via a
  // render-time <Redirect> on a persisted flag, which would strand this page on
  // every later visit once the flag was set.
  handleAdd = values => (
    this.props.actions.featuredCollections.add(values).then(action => {
      if (action.type === actionTypes.FEATURED_COLLECTION__ADD_SUCCESS) {
        this.props.history.push('/');
      }
    })
  )

  render() {
    return (
      <AllFeaturedCollections
        addFeaturedCollection={ this.handleAdd }
        collections={ this.props.collections }
        isActive={ this.props.isActive }
        location={ this.props.location }
      />
    );
  }
}

function mapStateToProps({ featuredCollections }) {
  return {
    collections : featuredCollections.getIn(['loaded', 'all']),
    isActive    : featuredCollections.get('isActive'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions : {
      featuredCollections : bindActionCreators(featuredCollectionsActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FunctionalAll);
